/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  CustomQuestionnaireAnswerSetSource,
  OverrideJustification,
  OverrideJustificationArtefact,
  PaginatedOverrideJustificationArtefactList,
  PaginatedOverrideJustificationList,
  PaginatedResidualRiskLabelList,
  PaginatedRiskDimensionLabelDetailList,
  PaginatedRiskProfileDimensionRiskList,
  PaginatedRiskProfileResidualRiskList,
  PaginatedRiskProfileSummaryList,
  PatchedOverrideJustification,
  PatchedRiskProfileDimensionRisk,
  PatchedRiskProfileResidualRisk,
  ResidualRiskLabel,
  RiskDimensionLabelDetail,
  RiskProfile,
  RiskProfileCreate,
  RiskProfileDimensionMatrix,
  RiskProfileDimensionMatrixAll,
  RiskProfileDimensionRisk,
  RiskProfileDimensionRiskUpdate,
  RiskProfileResidualRisk,
  RiskProfileResidualRiskUpdate,
} from '../models/index';
import {
  CustomQuestionnaireAnswerSetSourceFromJSON,
  CustomQuestionnaireAnswerSetSourceToJSON,
  OverrideJustificationFromJSON,
  OverrideJustificationToJSON,
  OverrideJustificationArtefactFromJSON,
  OverrideJustificationArtefactToJSON,
  PaginatedOverrideJustificationArtefactListFromJSON,
  PaginatedOverrideJustificationArtefactListToJSON,
  PaginatedOverrideJustificationListFromJSON,
  PaginatedOverrideJustificationListToJSON,
  PaginatedResidualRiskLabelListFromJSON,
  PaginatedResidualRiskLabelListToJSON,
  PaginatedRiskDimensionLabelDetailListFromJSON,
  PaginatedRiskDimensionLabelDetailListToJSON,
  PaginatedRiskProfileDimensionRiskListFromJSON,
  PaginatedRiskProfileDimensionRiskListToJSON,
  PaginatedRiskProfileResidualRiskListFromJSON,
  PaginatedRiskProfileResidualRiskListToJSON,
  PaginatedRiskProfileSummaryListFromJSON,
  PaginatedRiskProfileSummaryListToJSON,
  PatchedOverrideJustificationFromJSON,
  PatchedOverrideJustificationToJSON,
  PatchedRiskProfileDimensionRiskFromJSON,
  PatchedRiskProfileDimensionRiskToJSON,
  PatchedRiskProfileResidualRiskFromJSON,
  PatchedRiskProfileResidualRiskToJSON,
  ResidualRiskLabelFromJSON,
  ResidualRiskLabelToJSON,
  RiskDimensionLabelDetailFromJSON,
  RiskDimensionLabelDetailToJSON,
  RiskProfileFromJSON,
  RiskProfileToJSON,
  RiskProfileCreateFromJSON,
  RiskProfileCreateToJSON,
  RiskProfileDimensionMatrixFromJSON,
  RiskProfileDimensionMatrixToJSON,
  RiskProfileDimensionMatrixAllFromJSON,
  RiskProfileDimensionMatrixAllToJSON,
  RiskProfileDimensionRiskFromJSON,
  RiskProfileDimensionRiskToJSON,
  RiskProfileDimensionRiskUpdateFromJSON,
  RiskProfileDimensionRiskUpdateToJSON,
  RiskProfileResidualRiskFromJSON,
  RiskProfileResidualRiskToJSON,
  RiskProfileResidualRiskUpdateFromJSON,
  RiskProfileResidualRiskUpdateToJSON,
} from '../models/index';

export interface ApiDimensionLabelsListRequest {
  dimension?: number;
  page?: number;
}

export interface ApiDimensionLabelsRetrieveRequest {
  id: number;
}

export interface ApiDimensionRisksListRequest {
  dimension?: number;
  page?: number;
  residualRiskRisk?: number;
  residualRiskRiskProfile?: number;
  residualRiskRiskProfileUseCase?: number;
}

export interface ApiDimensionRisksPartialUpdateRequest {
  id: number;
  patchedRiskProfileDimensionRisk?: Omit<PatchedRiskProfileDimensionRisk, 'id' | 'dimension' | 'calculatedRiskLabel'>;
}

export interface ApiDimensionRisksRetrieveRequest {
  id: number;
}

export interface ApiDimensionRisksUpdateRequest {
  id: number;
  riskProfileDimensionRiskUpdate?: Omit<RiskProfileDimensionRiskUpdate, 'id'>;
}

export interface ApiOverrideJustificationArtefactsCreateRequest {
  overrideJustificationArtefact: Omit<OverrideJustificationArtefact, 'id'>;
}

export interface ApiOverrideJustificationArtefactsDestroyRequest {
  id: number;
}

export interface ApiOverrideJustificationArtefactsListRequest {
  page?: number;
}

export interface ApiOverrideJustificationArtefactsRetrieveRequest {
  id: number;
}

export interface ApiOverrideJustificationsCreateRequest {
  overrideJustification?: Omit<OverrideJustification, 'id' | 'artefacts'>;
}

export interface ApiOverrideJustificationsDestroyRequest {
  id: number;
}

export interface ApiOverrideJustificationsListRequest {
  page?: number;
}

export interface ApiOverrideJustificationsPartialUpdateRequest {
  id: number;
  patchedOverrideJustification?: Omit<PatchedOverrideJustification, 'id' | 'artefacts'>;
}

export interface ApiOverrideJustificationsRetrieveRequest {
  id: number;
}

export interface ApiOverrideJustificationsUpdateRequest {
  id: number;
  overrideJustification?: Omit<OverrideJustification, 'id' | 'artefacts'>;
}

export interface ApiResidualRiskLabelsListRequest {
  page?: number;
}

export interface ApiResidualRiskLabelsRetrieveRequest {
  id: number;
}

export interface ApiResidualRisksListRequest {
  isApplicable?: boolean;
  page?: number;
  risk?: number;
  riskProfile?: number;
  riskProfileUseCase?: number;
}

export interface ApiResidualRisksPartialUpdateRequest {
  id: number;
  patchedRiskProfileResidualRisk?: Omit<
    PatchedRiskProfileResidualRisk,
    'id' | 'risk' | 'calculatedRiskLabel' | 'riskLabel'
  >;
}

export interface ApiResidualRisksRetrieveRequest {
  id: number;
}

export interface ApiResidualRisksUpdateRequest {
  id: number;
  riskProfileResidualRiskUpdate?: Omit<RiskProfileResidualRiskUpdate, 'id'>;
}

export interface ApiRiskProfileDimensionMatrixAllRetrieveRequest {
  date?: string;
  departments?: Array<string>;
  useCases?: Array<string>;
}

export interface ApiRiskProfileDimensionMatrixRetrieveRequest {
  id: number;
}

export interface ApiRiskProfilesCreateRequest {
  riskProfileCreate: Omit<RiskProfileCreate, 'id' | 'residualRisks'>;
}

export interface ApiRiskProfilesDestroyRequest {
  id: number;
}

export interface ApiRiskProfilesListRequest {
  page?: number;
  useCase?: number;
}

export interface ApiRiskProfilesQuestionnaireAnswerSourcesCreateRequest {
  id: number;
  customQuestionnaireAnswerSetSource: Omit<CustomQuestionnaireAnswerSetSource, 'id' | 'questionnaireName'>;
}

export interface ApiRiskProfilesRetrieveRequest {
  id: number;
}

/**
 *
 */
export class RiskProfileApi extends runtime.BaseAPI {
  /**
   */
  async apiDimensionLabelsListRaw(
    requestParameters: ApiDimensionLabelsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedRiskDimensionLabelDetailList>> {
    const queryParameters: any = {};

    if (requestParameters['dimension'] != null) {
      queryParameters['dimension'] = requestParameters['dimension'];
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dimension_labels/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedRiskDimensionLabelDetailListFromJSON(jsonValue));
  }

  /**
   */
  async apiDimensionLabelsList(
    requestParameters: ApiDimensionLabelsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedRiskDimensionLabelDetailList> {
    const response = await this.apiDimensionLabelsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDimensionLabelsRetrieveRaw(
    requestParameters: ApiDimensionLabelsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskDimensionLabelDetail>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDimensionLabelsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dimension_labels/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskDimensionLabelDetailFromJSON(jsonValue));
  }

  /**
   */
  async apiDimensionLabelsRetrieve(
    requestParameters: ApiDimensionLabelsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskDimensionLabelDetail> {
    const response = await this.apiDimensionLabelsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDimensionRisksListRaw(
    requestParameters: ApiDimensionRisksListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedRiskProfileDimensionRiskList>> {
    const queryParameters: any = {};

    if (requestParameters['dimension'] != null) {
      queryParameters['dimension'] = requestParameters['dimension'];
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['residualRiskRisk'] != null) {
      queryParameters['residual_risk__risk'] = requestParameters['residualRiskRisk'];
    }

    if (requestParameters['residualRiskRiskProfile'] != null) {
      queryParameters['residual_risk__risk_profile'] = requestParameters['residualRiskRiskProfile'];
    }

    if (requestParameters['residualRiskRiskProfileUseCase'] != null) {
      queryParameters['residual_risk__risk_profile__use_case'] = requestParameters['residualRiskRiskProfileUseCase'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dimension_risks/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedRiskProfileDimensionRiskListFromJSON(jsonValue));
  }

  /**
   */
  async apiDimensionRisksList(
    requestParameters: ApiDimensionRisksListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedRiskProfileDimensionRiskList> {
    const response = await this.apiDimensionRisksListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDimensionRisksPartialUpdateRaw(
    requestParameters: ApiDimensionRisksPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskProfileDimensionRisk>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDimensionRisksPartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dimension_risks/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedRiskProfileDimensionRiskToJSON(requestParameters['patchedRiskProfileDimensionRisk']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskProfileDimensionRiskFromJSON(jsonValue));
  }

  /**
   */
  async apiDimensionRisksPartialUpdate(
    requestParameters: ApiDimensionRisksPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskProfileDimensionRisk> {
    const response = await this.apiDimensionRisksPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDimensionRisksRetrieveRaw(
    requestParameters: ApiDimensionRisksRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskProfileDimensionRisk>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDimensionRisksRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dimension_risks/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskProfileDimensionRiskFromJSON(jsonValue));
  }

  /**
   */
  async apiDimensionRisksRetrieve(
    requestParameters: ApiDimensionRisksRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskProfileDimensionRisk> {
    const response = await this.apiDimensionRisksRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDimensionRisksUpdateRaw(
    requestParameters: ApiDimensionRisksUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskProfileDimensionRiskUpdate>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDimensionRisksUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/dimension_risks/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: RiskProfileDimensionRiskUpdateToJSON(requestParameters['riskProfileDimensionRiskUpdate']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskProfileDimensionRiskUpdateFromJSON(jsonValue));
  }

  /**
   */
  async apiDimensionRisksUpdate(
    requestParameters: ApiDimensionRisksUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskProfileDimensionRiskUpdate> {
    const response = await this.apiDimensionRisksUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiOverrideJustificationArtefactsCreateRaw(
    requestParameters: ApiOverrideJustificationArtefactsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<OverrideJustificationArtefact>> {
    if (requestParameters['overrideJustificationArtefact'] == null) {
      throw new runtime.RequiredError(
        'overrideJustificationArtefact',
        'Required parameter "overrideJustificationArtefact" was null or undefined when calling apiOverrideJustificationArtefactsCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/override_justification_artefacts/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: OverrideJustificationArtefactToJSON(requestParameters['overrideJustificationArtefact']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => OverrideJustificationArtefactFromJSON(jsonValue));
  }

  /**
   */
  async apiOverrideJustificationArtefactsCreate(
    requestParameters: ApiOverrideJustificationArtefactsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<OverrideJustificationArtefact> {
    const response = await this.apiOverrideJustificationArtefactsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiOverrideJustificationArtefactsDestroyRaw(
    requestParameters: ApiOverrideJustificationArtefactsDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiOverrideJustificationArtefactsDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/override_justification_artefacts/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async apiOverrideJustificationArtefactsDestroy(
    requestParameters: ApiOverrideJustificationArtefactsDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiOverrideJustificationArtefactsDestroyRaw(requestParameters, initOverrides);
  }

  /**
   */
  async apiOverrideJustificationArtefactsListRaw(
    requestParameters: ApiOverrideJustificationArtefactsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedOverrideJustificationArtefactList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/override_justification_artefacts/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PaginatedOverrideJustificationArtefactListFromJSON(jsonValue),
    );
  }

  /**
   */
  async apiOverrideJustificationArtefactsList(
    requestParameters: ApiOverrideJustificationArtefactsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedOverrideJustificationArtefactList> {
    const response = await this.apiOverrideJustificationArtefactsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiOverrideJustificationArtefactsRetrieveRaw(
    requestParameters: ApiOverrideJustificationArtefactsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<OverrideJustificationArtefact>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiOverrideJustificationArtefactsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/override_justification_artefacts/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => OverrideJustificationArtefactFromJSON(jsonValue));
  }

  /**
   */
  async apiOverrideJustificationArtefactsRetrieve(
    requestParameters: ApiOverrideJustificationArtefactsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<OverrideJustificationArtefact> {
    const response = await this.apiOverrideJustificationArtefactsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiOverrideJustificationsCreateRaw(
    requestParameters: ApiOverrideJustificationsCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<OverrideJustification>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/override_justifications/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: OverrideJustificationToJSON(requestParameters['overrideJustification']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => OverrideJustificationFromJSON(jsonValue));
  }

  /**
   */
  async apiOverrideJustificationsCreate(
    requestParameters: ApiOverrideJustificationsCreateRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<OverrideJustification> {
    const response = await this.apiOverrideJustificationsCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiOverrideJustificationsDestroyRaw(
    requestParameters: ApiOverrideJustificationsDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiOverrideJustificationsDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/override_justifications/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async apiOverrideJustificationsDestroy(
    requestParameters: ApiOverrideJustificationsDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiOverrideJustificationsDestroyRaw(requestParameters, initOverrides);
  }

  /**
   */
  async apiOverrideJustificationsListRaw(
    requestParameters: ApiOverrideJustificationsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedOverrideJustificationList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/override_justifications/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedOverrideJustificationListFromJSON(jsonValue));
  }

  /**
   */
  async apiOverrideJustificationsList(
    requestParameters: ApiOverrideJustificationsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedOverrideJustificationList> {
    const response = await this.apiOverrideJustificationsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiOverrideJustificationsPartialUpdateRaw(
    requestParameters: ApiOverrideJustificationsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<OverrideJustification>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiOverrideJustificationsPartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/override_justifications/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedOverrideJustificationToJSON(requestParameters['patchedOverrideJustification']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => OverrideJustificationFromJSON(jsonValue));
  }

  /**
   */
  async apiOverrideJustificationsPartialUpdate(
    requestParameters: ApiOverrideJustificationsPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<OverrideJustification> {
    const response = await this.apiOverrideJustificationsPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiOverrideJustificationsRetrieveRaw(
    requestParameters: ApiOverrideJustificationsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<OverrideJustification>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiOverrideJustificationsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/override_justifications/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => OverrideJustificationFromJSON(jsonValue));
  }

  /**
   */
  async apiOverrideJustificationsRetrieve(
    requestParameters: ApiOverrideJustificationsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<OverrideJustification> {
    const response = await this.apiOverrideJustificationsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiOverrideJustificationsUpdateRaw(
    requestParameters: ApiOverrideJustificationsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<OverrideJustification>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiOverrideJustificationsUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/override_justifications/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: OverrideJustificationToJSON(requestParameters['overrideJustification']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => OverrideJustificationFromJSON(jsonValue));
  }

  /**
   */
  async apiOverrideJustificationsUpdate(
    requestParameters: ApiOverrideJustificationsUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<OverrideJustification> {
    const response = await this.apiOverrideJustificationsUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiResidualRiskLabelsListRaw(
    requestParameters: ApiResidualRiskLabelsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedResidualRiskLabelList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/residual_risk_labels/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedResidualRiskLabelListFromJSON(jsonValue));
  }

  /**
   */
  async apiResidualRiskLabelsList(
    requestParameters: ApiResidualRiskLabelsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedResidualRiskLabelList> {
    const response = await this.apiResidualRiskLabelsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiResidualRiskLabelsRetrieveRaw(
    requestParameters: ApiResidualRiskLabelsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ResidualRiskLabel>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiResidualRiskLabelsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/residual_risk_labels/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => ResidualRiskLabelFromJSON(jsonValue));
  }

  /**
   */
  async apiResidualRiskLabelsRetrieve(
    requestParameters: ApiResidualRiskLabelsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ResidualRiskLabel> {
    const response = await this.apiResidualRiskLabelsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiResidualRisksListRaw(
    requestParameters: ApiResidualRisksListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedRiskProfileResidualRiskList>> {
    const queryParameters: any = {};

    if (requestParameters['isApplicable'] != null) {
      queryParameters['is_applicable'] = requestParameters['isApplicable'];
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['risk'] != null) {
      queryParameters['risk'] = requestParameters['risk'];
    }

    if (requestParameters['riskProfile'] != null) {
      queryParameters['risk_profile'] = requestParameters['riskProfile'];
    }

    if (requestParameters['riskProfileUseCase'] != null) {
      queryParameters['risk_profile__use_case'] = requestParameters['riskProfileUseCase'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/residual_risks/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedRiskProfileResidualRiskListFromJSON(jsonValue));
  }

  /**
   */
  async apiResidualRisksList(
    requestParameters: ApiResidualRisksListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedRiskProfileResidualRiskList> {
    const response = await this.apiResidualRisksListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiResidualRisksPartialUpdateRaw(
    requestParameters: ApiResidualRisksPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskProfileResidualRisk>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiResidualRisksPartialUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/residual_risks/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: PatchedRiskProfileResidualRiskToJSON(requestParameters['patchedRiskProfileResidualRisk']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskProfileResidualRiskFromJSON(jsonValue));
  }

  /**
   */
  async apiResidualRisksPartialUpdate(
    requestParameters: ApiResidualRisksPartialUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskProfileResidualRisk> {
    const response = await this.apiResidualRisksPartialUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiResidualRisksRetrieveRaw(
    requestParameters: ApiResidualRisksRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskProfileResidualRisk>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiResidualRisksRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/residual_risks/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskProfileResidualRiskFromJSON(jsonValue));
  }

  /**
   */
  async apiResidualRisksRetrieve(
    requestParameters: ApiResidualRisksRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskProfileResidualRisk> {
    const response = await this.apiResidualRisksRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiResidualRisksUpdateRaw(
    requestParameters: ApiResidualRisksUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskProfileResidualRiskUpdate>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiResidualRisksUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/residual_risks/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: RiskProfileResidualRiskUpdateToJSON(requestParameters['riskProfileResidualRiskUpdate']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskProfileResidualRiskUpdateFromJSON(jsonValue));
  }

  /**
   */
  async apiResidualRisksUpdate(
    requestParameters: ApiResidualRisksUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskProfileResidualRiskUpdate> {
    const response = await this.apiResidualRisksUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Return counts for entire portfolio with optional filters by department, use case, and cutoff date.
   */
  async apiRiskProfileDimensionMatrixAllRetrieveRaw(
    requestParameters: ApiRiskProfileDimensionMatrixAllRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskProfileDimensionMatrixAll>> {
    const queryParameters: any = {};

    if (requestParameters['date'] != null) {
      queryParameters['date'] = requestParameters['date'];
    }

    if (requestParameters['departments'] != null) {
      queryParameters['departments'] = requestParameters['departments'];
    }

    if (requestParameters['useCases'] != null) {
      queryParameters['use_cases'] = requestParameters['useCases'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_profile_dimension_matrix/all/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskProfileDimensionMatrixAllFromJSON(jsonValue));
  }

  /**
   * Return counts for entire portfolio with optional filters by department, use case, and cutoff date.
   */
  async apiRiskProfileDimensionMatrixAllRetrieve(
    requestParameters: ApiRiskProfileDimensionMatrixAllRetrieveRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskProfileDimensionMatrixAll> {
    const response = await this.apiRiskProfileDimensionMatrixAllRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * ViewSet for Risk Profile Dimension Matrix.
   */
  async apiRiskProfileDimensionMatrixRetrieveRaw(
    requestParameters: ApiRiskProfileDimensionMatrixRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskProfileDimensionMatrix>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRiskProfileDimensionMatrixRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_profile_dimension_matrix/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskProfileDimensionMatrixFromJSON(jsonValue));
  }

  /**
   * ViewSet for Risk Profile Dimension Matrix.
   */
  async apiRiskProfileDimensionMatrixRetrieve(
    requestParameters: ApiRiskProfileDimensionMatrixRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskProfileDimensionMatrix> {
    const response = await this.apiRiskProfileDimensionMatrixRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiRiskProfilesCreateRaw(
    requestParameters: ApiRiskProfilesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskProfileCreate>> {
    if (requestParameters['riskProfileCreate'] == null) {
      throw new runtime.RequiredError(
        'riskProfileCreate',
        'Required parameter "riskProfileCreate" was null or undefined when calling apiRiskProfilesCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_profiles/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: RiskProfileCreateToJSON(requestParameters['riskProfileCreate']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskProfileCreateFromJSON(jsonValue));
  }

  /**
   */
  async apiRiskProfilesCreate(
    requestParameters: ApiRiskProfilesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskProfileCreate> {
    const response = await this.apiRiskProfilesCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiRiskProfilesDestroyRaw(
    requestParameters: ApiRiskProfilesDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRiskProfilesDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_profiles/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async apiRiskProfilesDestroy(
    requestParameters: ApiRiskProfilesDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiRiskProfilesDestroyRaw(requestParameters, initOverrides);
  }

  /**
   */
  async apiRiskProfilesListRaw(
    requestParameters: ApiRiskProfilesListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedRiskProfileSummaryList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['useCase'] != null) {
      queryParameters['use_case'] = requestParameters['useCase'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_profiles/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PaginatedRiskProfileSummaryListFromJSON(jsonValue));
  }

  /**
   */
  async apiRiskProfilesList(
    requestParameters: ApiRiskProfilesListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedRiskProfileSummaryList> {
    const response = await this.apiRiskProfilesListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates or updates existing questionnaire answer source. If source with the same questionnaire id exists perform updates, otherwise create new one.
   */
  async apiRiskProfilesQuestionnaireAnswerSourcesCreateRaw(
    requestParameters: ApiRiskProfilesQuestionnaireAnswerSourcesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskProfile>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRiskProfilesQuestionnaireAnswerSourcesCreate().',
      );
    }

    if (requestParameters['customQuestionnaireAnswerSetSource'] == null) {
      throw new runtime.RequiredError(
        'customQuestionnaireAnswerSetSource',
        'Required parameter "customQuestionnaireAnswerSetSource" was null or undefined when calling apiRiskProfilesQuestionnaireAnswerSourcesCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_profiles/{id}/questionnaire-answer-sources/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CustomQuestionnaireAnswerSetSourceToJSON(requestParameters['customQuestionnaireAnswerSetSource']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskProfileFromJSON(jsonValue));
  }

  /**
   * Creates or updates existing questionnaire answer source. If source with the same questionnaire id exists perform updates, otherwise create new one.
   */
  async apiRiskProfilesQuestionnaireAnswerSourcesCreate(
    requestParameters: ApiRiskProfilesQuestionnaireAnswerSourcesCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskProfile> {
    const response = await this.apiRiskProfilesQuestionnaireAnswerSourcesCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiRiskProfilesRetrieveRaw(
    requestParameters: ApiRiskProfilesRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<RiskProfile>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiRiskProfilesRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/risk_profiles/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters['id']))),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => RiskProfileFromJSON(jsonValue));
  }

  /**
   */
  async apiRiskProfilesRetrieve(
    requestParameters: ApiRiskProfilesRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<RiskProfile> {
    const response = await this.apiRiskProfilesRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
